import { Box, Text } from '@factorialco/deprecated-design-system'

import {
  formatDateRange,
  parseBackendDate,
} from 'modules/core/components/DateNavigator/dateFormatUtils'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { SummaryCard } from 'modules/insights/components/SummaryCard'
import {
  getColorHeadCount,
  getColorJoiners,
  getColorLeavers,
} from 'modules/insights/components/WidgetHeadcountEvolution/ChartHeadcountEvolution/headcountEvolutionUtils'
import type HeadcountEvolution from 'modules/insights/lib/metrics/headcountEvolution'

type Props = {
  headcountEvolution: HeadcountEvolution
  date: Date | undefined
}

export const HeadcountCounters = ({ headcountEvolution, date }: Props) => {
  const currentRange = useUnsafeMemo(() => {
    if (date) {
      const dateString = dateToString(date, 'backend')

      const selectedElement = headcountEvolution.headcountEvolution.find(
        (record) => record.endDate === dateString
      )

      if (selectedElement) {
        return {
          startDate: parseBackendDate(selectedElement.startDate),
          endDate: parseBackendDate(selectedElement.endDate),
        }
      }
    }
  }, [headcountEvolution, date])

  const selectedRangeMetrics = useUnsafeMemo(() => {
    if (date) {
      return headcountEvolution.generateMetrics(date)
    }
  }, [headcountEvolution, date])

  if (!currentRange || !selectedRangeMetrics) {
    return null
  }

  return (
    <Box flexDirection="column" gap="s16" minWidth="s140">
      <Text.Normal>
        {formatDateRange(currentRange.startDate, currentRange.endDate, true, false)}
      </Text.Normal>

      <Box flexDirection="column" gap="s24">
        <SummaryCard
          title={i18n.t('insights.widgets.shared.headcount')}
          value={selectedRangeMetrics.headcount}
          color={getColorHeadCount()}
        />
        <SummaryCard
          title={i18n.t('insights.widgets.headcount_evolution.joiners')}
          value={selectedRangeMetrics.joiners}
          color={getColorJoiners()}
        />
        <SummaryCard
          title={i18n.t('insights.widgets.headcount_evolution.leavers')}
          value={selectedRangeMetrics.leavers}
          color={getColorLeavers()}
        />
      </Box>
    </Box>
  )
}
